/**
 * クッキーのキーを表します。
 */
export class N302SessionStorageKey {

  public static readonly N3021HIDUKEKUBUN: string = 'N3021HIDUKEKUBUN';
  public static readonly N3021HIDUKESTART: string = 'N3021HIDUKESTART';
  public static readonly N3021HIDUKEEND: string = 'N3021HIDUKEEND';

  public static readonly N3021SYUKABI: string = 'N3021SYUKABI';
  public static readonly N3021SYUKAKAKUTEIBI: string = 'N3021SYUKAKAKUTEIBI';
  public static readonly N3021GOSYA: string = 'N3021GOSYA';
  public static readonly N3021ZAKOSOKO: string = 'N3021ZAKOSOKO';
  public static readonly N3021UNSOKAISYA: string = 'N3021UNSOKAISYA';
  public static readonly N3021YUSOUKEITAIKUBUN: string = 'N3021YUSOUKEITAIKUBUN';
  public static readonly N3021TOUROKUJOKYO: string = 'N3021TOUROKUJOKYO';
  public static readonly N3021TOUROKUJOKYO1: string = 'N3021TOUROKUJOKYO1';
  public static readonly N3021TOUROKUJOKYO2: string = 'N3021TOUROKUJOKYO2';
  public static readonly N3021TOUROKUJOKYO3: string = 'N3021TOUROKUJOKYO3';

  public static readonly N3021NICHIHAEIGYOSHO: string = 'N3021NICHIHAEIGYOSHO';
  public static readonly N3021JYUTYUBANGO: string = 'N3021JYUTYUBANGO';

  public static readonly N3021ATENA: string = 'N3021ATENA';
  public static readonly N3021OKYAUKSAMATYUMONNO: string = 'N3021OKYAUKSAMATYUMONNO';

  public static readonly N3021HAISOKEITAI: string = 'N3021HAISOKEITAI';
  public static readonly N3021HAISOKEITAI1: string = 'N3021HAISOKEITAI1';
  public static readonly N3021HAISOKEITAI2: string = 'N3021HAISOKEITAI2';
  public static readonly N3021HAISOKEITAI3: string = 'N3021HAISOKEITAI3';
  public static readonly N3021HINBAN: string = 'N3021HINBAN';

  public static readonly N3021KENCHIKUKAISYASAMAMEI: string = 'N3021KENCHIKUKAISYASAMAMEI';

  public static readonly N3021BUKENMEI: string = 'N3021BUKENMEI';
  public static readonly N3021HAISORUTO: string = 'N3021HAISORUTO';
  public static readonly N3021HAISORUTOHYOUJI: string = 'N3021HAISORUTOHYOUJI';
  public static readonly N3021HAISORUTOHIDDEN: string = 'N3021HAISORUTOHIDDEN';

  public static readonly N3021SYUKAYOBIKO: string = 'N3021SYUKAYOBIKO';
  public static readonly N3021SYABAN: string = 'N3021SYABAN';

  public static readonly N3021CHUMONHOHO: string = 'N3021CHUMONHOHO';
  public static readonly N3021CHUMONHOHO1: string = 'N3021CHUMONHOHO1';
  public static readonly N3021CHUMONHOHO2: string = 'N3021CHUMONHOHO2';
  public static readonly N3021NARABIJYUN: string = 'N3021NARABIJYUN';

  public static readonly N3021KAKOEIGYOUBI5: string = 'N3021KAKOEIGYOUBI5';
  public static readonly N3021KAKOEIGYOUBI10: string = 'N3021KAKOEIGYOUBI10';

  public static readonly N3021APISHIYOKAHIFURAGU: string = 'N3021APISHIYOKAHIFURAGU';
  public static readonly N3021SAIDAISENTAKUSU: string = 'N3021SAIDAISENTAKUSU';

  // 検索ボタン押下時の検索条件
  public static readonly N3021SessionSearchData: string = 'N3021SessionSearchData';
}



// WEBPACK FOOTER //
// ./src/app/modules/n302/n302-session-storage-key.ts